module.exports = __webpack_public_path__ + "img/copy-icon-new.1209743e.svg";